module.exports = __webpack_public_path__ + "static/media/section9.34512bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section9.png
// module id = 305
// module chunks = 0